import { ConcreteEncodable } from "./ConcreteEncodable";

import { SavedProfileRequestImplEncoder } from "../../encoder/SavedProfileRequestImplEncoder";

import * as CubiqTS from "../../index";
import { SavedProfileRequest } from "../SavedProfileRequest";

export class SavedProfileRequestImpl extends ConcreteEncodable implements SavedProfileRequest {
  public static enType: string = "com.bcdfx.model.event.SavedProfileRequestImpl";

  /*FID=1*/
  public profileDescriptors: Array<CubiqTS.DataProfileDescriptor> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SavedProfileRequestImplEncoder.Instance;
    this.setEncodableType(SavedProfileRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "SavedProfileRequestImpl[" +
      "profileDescriptors=" +
      this.profileDescriptors +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
